export function getEstimateNumber(estimate: {
  number: number | null;
  numberPrefix?: string | null;
}): string {
  return (
    (estimate.numberPrefix ? estimate.numberPrefix : '') + (estimate.number ? estimate.number : '')
  );
}

export type EstimateItemForCalculation = {
  quantity: number;
  unitPrice: number;
  taxRate: number;
};

export type TaxValue = {
  taxRate: number;
  taxAmount: string;
  taxAmountRaw: number;
  netAmount: string;
};

export function calculateNetAmount(items: readonly EstimateItemForCalculation[]): number {
  let netAmount = 0;
  for (const item of items) {
    netAmount += parseInt((item.unitPrice * item.quantity).toFixed(0));
  }
  return netAmount;
}

export function calculateNetAmountsByTaxes(items: readonly EstimateItemForCalculation[]): number[] {
  const netAmounts: number[] = [];

  for (const item of items) {
    let currentNetAmount: number = netAmounts[item.taxRate];
    if (currentNetAmount == null) {
      currentNetAmount = parseInt((item.unitPrice * item.quantity).toFixed(0));
    } else {
      currentNetAmount += parseInt((item.unitPrice * item.quantity).toFixed(0));
    }
    netAmounts[item.taxRate] = currentNetAmount;
  }

  return netAmounts;
}

export function calculateTaxValues(items: readonly EstimateItemForCalculation[]): TaxValue[] {
  const netAmounts = calculateNetAmountsByTaxes(items);
  const taxValuesList: TaxValue[] = [];

  for (const key in netAmounts) {
    const taxRateRaw = parseInt(key);
    const taxRate = taxRateRaw / 100;
    const taxAmount = parseInt((netAmounts[key] * taxRate).toFixed(0));
    const taxAmountParsed = taxAmount / 100;
    const netAmountParsed = netAmounts[key] / 100;

    taxValuesList.push({
      taxRate: taxRateRaw,
      taxAmount: formatMoney(taxAmountParsed),
      taxAmountRaw: taxAmount,
      netAmount: formatMoney(netAmountParsed),
    });
  }

  return taxValuesList;
}

export function calculateTotalAmount(items: readonly EstimateItemForCalculation[]): number {
  const netAmount = calculateNetAmount(items);
  const taxValues = calculateTaxValues(items);

  let totalTaxAmount = 0;
  for (const taxValue of taxValues) {
    totalTaxAmount += taxValue.taxAmountRaw;
  }

  return netAmount + totalTaxAmount;
}

function formatMoney(value: number): string {
  return value.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
